import { accountReducer } from 'app/actions/auth';
import { combineReducers } from 'redux';

// Load reducers
const rootReducer = combineReducers({
  account: accountReducer
});

export default rootReducer;
